// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"24":"5b21c5df","152":"e2051c3b","642":"d3f58738"}[chunkId] + ".chunk.js");